import { EContactTypeV2, EServiceType } from './common';
import { BillingPolicyType } from './paymentSetup';
import type { TFormGroup } from './textVisit';

export enum EventStatus {
    CONFIRMED = 'confirmed',
    ACCEPTED = 'accepted',
    DECLINED = 'declined',
    NEEDSACTION = 'needsAction',
}

export enum EntryPointType {
    VIDEO = 'video',
    PHONE = 'phone',
    MORE = 'more',
}

export enum ReminderOverrideMethod {
    EMAIL = 'email',
    POPUP = 'popup',
}

export type EventUser = {
    email: string;
};

export type EventAttendee = {
    email: string;
    displayName?: string;
    self?: true;
    organizer?: true;
    responseStatus?: EventStatus;
};

export type EventTime = {
    dateTime: string; //'2022-12-28T08:15:00+08:00',
    timeZone: string; //'America/Los_Angeles'
};

// {
//     "entryPointType": "video",
//     "uri": "https://us06web.zoom.us/j/83815658913?pwd=Ym5FUUIwa2x0Y0VtL000OW5jdDdXZz09",
//     "label": "us06web.zoom.us/j/83815658913?pwd=Ym5FUUIwa2x0Y0VtL000OW5jdDdXZz09",
//     "meetingCode": "83815658913",
//     "passcode": "620712"
//   },

export type EntryPoint = {
    entryPointType: EntryPointType;
    uri?: string;
    label?: string;
    meetingCode?: string;
    passcode: string;
};

export type ReminderOverride = {
    method: ReminderOverrideMethod;
    minutes: number;
};
export interface Event {
    kind?: string;
    etag?: string;
    location?: string;
    colorId?: string;
    color?: string;
    description: string;
    taskDayKey?: string | null;
    id: string;
    status?: EventStatus;
    htmlLink?: string;
    created?: string; //'2022-11-25T19:55:49.000Z',
    updated?: string; //'2022-12-26T07:38:06.385Z',
    summary: string;
    recurrence?: string[];
    creator?: EventUser;
    organizer?: EventUser;
    start: EventTime;
    end: EventTime;
    serviceSpecialty?: string | null;
    recurringEventId?: string;
    originalStartTime?: EventTime;
    iCalUID?: string;
    sequence?: number;
    appointmentStatus?: EScheduleStatusValue | string | null;
    attendees?: EventAttendee[];
    scheduledBy?: EScheduledBy | string | null; // "provider-scheduled",
    eventType?: string;
    channelId?: string;
    serviceId?: string;
    duration?: number;
    meetingLink?: string;
    patientName?: string;
    patientPhone?: string;
    sendForm?: string;
    type?: 'appointment' | 'blocker' | 'google' | 'task';
    isSample?: boolean;
    isProtected?: boolean;
    divId?: string;
    clientId?: number;
    timezone?: string | null;
    providerId?: number | null;
}

export interface EventWithTimeOverlap extends Event {
    timeOverlapKeys: string[];
}

export type GoogleColor = {
    id: string;
    background: string; //'#ac725e',
    foreground: string; //'#1d1d1d'
};

export type Color = {
    id: number;
    type: 'COLOR';
    dictKey: string;
    content: string;
};

// {
//     "start": "2023-01-05T09:00:00.000-07:00",
//     "end": "2023-01-05T17:00:00.000-07:00",
//     "providerId": null,
//     "eventId": "2kep3qjcqu11nfum4ffg0otug4_20230105T160000Z",
//     "channelId": null,
//     "serviceId": null,
//     "duration": null,
//     "meetingLink": null,
//     "patientName": null,
//     "patientPhone": null,
//     "sendForm": null,
//     "colorId": null,
//     "description": "A chance to hear more about Google's developer products.",
//     "email": [
//       "youming.tang@helloklarity.com",
//       "xiaocong.liu@helloklarity.com"
//     ],
//     "location": "800 Howard St., San Francisco, CA 94103",
//     "recurrence": null,
//     "summary": "Test Event -Xiaocong",
//     "timeZone": null
//   },
export type ServerEvent = {
    start: string;
    end: string;
    eventId: string;
    colorId?: string;
    description: string;
    email?: string[];
    location?: string;
    recurrence?: string;
    summary: string;
    timeZone: string;
    providerId?: number;
    channelId?: string;
    serviceId?: string;
    serviceName?: string;
    duration?: number;
    meetingLink?: string;
    patientName?: string;
    patientPhone?: string;
    sendForm?: string;
};
// [
//     {
//         label: 'Does not repeat',
//         value: '1',
//     },
//     {
//         label: 'Daily',
//         value: '2',
//     },
//     {
//         label: `Weekly on ${day.format('dddd')}`, //Weekly on Friday
//         value: '3',
//     },
//     {
//         label: `Monthly on the first ${day.format('dddd')}`, //Monthly on the first Friday
//         value: '4',
//     },
//     {
//         label: `Monthly on the ${day.format('DD')}`, //Monthly on the 6th
//         value: '5',
//     },
//     {
//         label: 'Every weekday (Monday to Friday)',
//         value: '6',
//     },
// ];
export enum RecurringType {
    NOT_REPEAT = 'NOT_REPEAT',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY_ON_FIRST_WEEKDAY = 'MONTHLY_ON_FIRST_WEEKDAY',
    MONTHLY_ON_DATE = 'MONTHLY_ON_DATE',
    WEEKDAY = 'WEEKDAY',
}

export type TServerSimpleCalendarEvent = {
    id: number;
    startAt: string; //"2025-03-30T16:00:00Z",
    endAt: string; //"2025-03-30T16:30:00Z",
    title: string; //"Psychiatric & Mental Health: New patient initial visit",
    scheduledBy?: EScheduledBy | string | null; // "provider-scheduled",
    recurrenceRule: string | null;
    appointmentStatus?: EScheduleStatusValue | string | null;
    calendarColor?: string | null;
    serviceSpecialty?: string | null;
    clientId?: number | null;
    isSample?: boolean;
    timezone?: string | null;
    serviceType?: string | null;
    providerId?: number | null;
};

export enum EScheduledBy {
    KLARITY_BOOKED = 'klarity-booked',
    PROVIDER_SCHEDULED = 'provider-scheduled',
}

export enum EScheduleStatusLabel {
    SCHEDULED = 'Scheduled',
    SHOWED = 'Showed',
    PATIENT_NO_SHOW = 'Patient no show',
    PATIENT_CANCELED = 'Patient canceled',
    PATIENT_LATE_CANCELED = 'Patient late canceled',
    PROVIDER_CANCELED = 'Provider canceled',
}

export enum EScheduleStatusValue {
    SCHEDULED = 'scheduled',
    SHOWED = 'showed',
    PATIENT_NO_SHOW = 'patient-no-show',
    PATIENT_CANCELED = 'patient-canceled',
    PATIENT_LATE_CANCELED = 'patient-late-canceled',
    PROVIDER_CANCELED = 'provider-canceled',
}

export type TProviderAppointmentCancelInfo = {
    id: number;
    appointmentId: number;
    canceledType: string;
    canceledReason?: string;
    otherReason?: string;
    messageToPatient?: string;
    manualReason?: string;
    createdAt?: null;
    updatedAt?: null;
    isDeleted?: boolean;
    deletedAt?: null;
    confirmCharge?: boolean;
};

export type TProviderAppointmentBilling = {
    id: number;
    appointmentId: number;
    providerId: number;
    clientId: number;
    klarityUserId: number;
    chargeType: BillingPolicyType | string; // "NO_SHOW/LATE_CANCELLATION/RESCHEDULE",
    relationId: number;
    // "PENDING/PROCESSING/SUCCEEDED/FAILED/NOT_READY" from provider_appointment_billing,
    // plus "REFUNDED" which only klarity_user_billing produces
    billingStatus: string;
    amountCents: number;
    refundAmountCents?: number;
    // Null/PROVIDER_APPOINTMENT_BILLING = legacy Stripe table; anything else is the
    // klarity_user_billing billing_source. The two tables have independent id sequences,
    // so list keys must combine billingSource + id.
    billingSource?: string;
    chargeSucceedAt?: string;
    createdAt?: string;
    stripePaymentIntentId: string; //"stripePaymentIntentId_f3df8ca45114",
    stripeChargeId: string; // "stripeChargeId_f5342611542f",
    errorCode: string; // "errorCode_e0d5eb7443a7",
    errorMessage: string; //"errorMessage_288fa1d5e454"
};
// NONE=no intake form;
// REQUIRED=required but not started;
// IN_PROGRESS=started but not completed;
// COMPLETED=completed

export enum EIntakeFormStatus {
    NONE = 'NONE',
    REQUIRED = 'REQUIRED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
}

export type TServerCalendarAppointmentEventDetail = {
    id?: number; // 8,
    appointmentName: string; // "Annual Check-up-9-9-9?",
    clientId: number;
    startAt: string; // "2025-03-29T10:00:00Z",
    endAt: string; // "2025-03-29T10:30:00Z",
    createdAt: string; //
    duration: number;
    //video, in-person, telephone
    contactType?: EContactTypeV2;
    externalVideoLink?: string;
    // TODO: Reserved field to determine if it's the default video service
    isDefaultVideo?: boolean;
    notes?: string;
    reason?: string;
    scheduledBy?: EScheduledBy; // "provider-scheduled",
    serviceType?: EServiceType | string;
    serviceSpecialty?: string; //"Family Medicine",
    location?: string; //"Video visit",
    appointmentStatus?: EScheduleStatusValue; //"",
    appointmentStatusChangedAt?: null | string;
    providerConfirm?: boolean;
    providerConfirmAt?: null | string;
    clientConfirm?: boolean;
    clientConfirmAt?: null | string;
    serviceState?: string;
    serviceId?: number;
    calendarColor?: string;
    messageToPatient?: string;
    isSample?: boolean;

    providerId?: number;
    actualDuration?: number;
    telephone?: string;
    recurringAppointmentId?: number;
    providerAppointmentCancelInfo?: TProviderAppointmentCancelInfo;
    relationship?: string;
    providerAppointmentBillings?: TProviderAppointmentBilling[];
    providerFirstName?: string;
    providerLastName?: string;
    serviceItemId: number;
    intakeFormStatus: EIntakeFormStatus;
    completedIntakeFormGroups?: TFormGroup[];
    paymentSource?: EAppointmentPaymentSource;
    canReassign?: boolean;
    isInProgress?: boolean;
    payType?: 'CASH_PAY' | 'INSURANCE';
    tz?: string; //provider 时区
};

export enum EAppointmentPaymentSource {
    INSURANCE = 'INSURANCE',
    SELF_PAY = 'SELF_PAY',
}

export enum ERepeatType {
    DOES_NOT_REPEAT = 0,
    DAILY = 1,
    WEEKLY_ON_WEEKDAY = 2,
    MONTHLY_ON_FIRST_DAY = 3,
    MONTHLY_ON_DATE = 4,
    EVERY_WEEKDAY = 5,
}

export type TServerCalendarBlockerEventDetail = {
    id?: number;
    color?: string;
    providerId?: number;
    description?: string;
    title: string; // "Vacation-test-30-23",
    startAt: string; // "2025-03-29T09:00:00",
    endAt: string; //"2025-03-29T11:30:00",
    duration?: number;
    isAllDay: boolean;
    repeatType?: ERepeatType;
    isDeclineAppointment: boolean;
    messageToPatient?: string;
    repeatDesc?: string;
    repeatEndDate?: string;
    repeatDayOfWeek?: string;
    repeatDayOfMonth?: string;
    repeatWeekOfMonth?: string;
    recurrenceRule?: string;
    timezone?: string;
    isSample?: boolean;
};

export type TServerSimpleCalendarEventList = {
    appointmentList: TServerSimpleCalendarEvent[];
    blockerList: TServerSimpleCalendarEvent[];
    googleList: TServerSimpleCalendarEvent[];
    textVisitList?: TServerCalendarTextVisitSimple[];
};

export type TServerCalendarTextVisitSimple = {
    id: number;
    textVisitUuid?: string;
    clientId?: number;
    klarityUserId?: number;
    patientFirstName?: string;
    patientLastName?: string;
    specialty?: string;
    serviceType?: string;
    state?: string;
    status?: string;
    hasUnpaidOrFailedStatus?: boolean;
    isRecurring?: boolean;
    hasOutstandingBalance?: boolean;
    occurrenceIndex?: number | null;
    recurrenceId?: number | null;
    patientSubmitAt?: string;
    assignedProviderAt?: string;
    snoozeUntil?: string | null;
    updatedAt?: string;
    startAt?: string | null;
    endAt?: string | null;
    providerTreatmentSubmitted?: boolean;
    canModifyRecurrence?: boolean | null;
    providerId?: number | null;
};

export enum EProvicerCancelReasonLabel {
    SCHEDULE_CONFLICTS = 'Schedule conflicts',
    MISMATCH_WITH_SCOPE = 'Mismatch with scope/ Medication request',
    INSURANCE_MISMATCH = 'Insurance mismatch',
    OUTSTANDING_PAYMENTS = 'Outstanding payments',
    INCOMPLETE_PATIENT_INFORMATION = 'Incomplete patient information',
    OTHER_REASONS = 'Other reasons',
}

export enum EPatientCancelReasonLabel {
    PATIENT_HAS_SCHEDULE_CONFLICTS = 'Patient has schedule conflicts',
    PATIENT_DOES_NOT_HAVE_A_CREDIT_CARD_ON_FILE = "Patient doesn't have a credit card on file",
    PATIENT_IS_IRRESPONSIVE = 'Patient is irresponsive',
    PATIENT_WANTS_TO_FIND_ANOTHER = 'Patient wants to find / found another provider',
    PATIENT_WANTS_AN_EARLIER_APPOINTMENT = 'Patient wants an earlier appointment',
    PATIENT_DOES_NOT_HAVE_THE_INSURANCE_THAT_I_ACCEPT = "Patient doesn't have the insurance that I accept",
    OTHER_REASONS = 'Other reasons',
}
//枚举：ONLY_REMIND_PATIENT 是发邮件提醒 、DIRECT_UPDATE_TIME 更新时间
export enum ERescheduledAction {
    ONLY_REMIND_PATIENT = 'ONLY_REMIND_PATIENT',
    DIRECT_UPDATE_TIME = 'DIRECT_UPDATE_TIME',
    NEW_APPOINTMENT = 'NEW_APPOINTMENT',
}

// {
//     "appointment": {
//       "actualDuration": 30,
//       "appointmentName": "",
//       "appointmentStatus": "",
//       "appointmentStatusChangedAt": "2025-01-15T10:00:00",
//       "calendarColor": "",
//       "clientConfirm": true,
//       "clientConfirmAt": "2025-01-15T10:00:00",
//       "clientId": 0,
//       "contactType": "",
//       "createdAt": "2025-01-15T10:00:00",
//       "duration": 0,
//       "emailSignature": "Dr. Smith",
//       "endAt": "",
//       "externalVideoLink": "",
//       "id": 0,
//       "isSample": false,
//       "klarityMeetingSessionKey": "abc123xyz",
//       "location": "",
//       "messageToPatient": "Please arrive 10 minutes early",
//       "notes": "",
//       "providerConfirm": true,
//       "providerConfirmAt": "2025-01-15T10:00:00",
//       "providerId": 0,
//       "reason": "",
//       "recurringAppointmentId": 0,
//       "scheduledBy": "",
//       "serviceId": 0,
//       "serviceSpecialty": "",
//       "serviceState": "",
//       "serviceType": "",
//       "startAt": "",
//       "telephone": "+1234567890",
//       "updatedAt": "2025-01-15T10:00:00"
//     },
//     "appointmentId": 0,
//     "emailSignature": "Dr. Smith",
//     "messageToPatient": "Your appointment has been updated",
//     "rescheduledAction": "NEW_APPOINTMENT",
//     "startAt": "2025-01-15T10:00:00Z"
//   }

export type TScheduleAFollowUpVisitByProvider = {
    appointmentId: number;
    emailSignature: string;
    rescheduledAction?: ERescheduledAction;
    startAt?: string;
    // endAt?: string;
    messageToPatient?: string;
    externalVideoLink?: string;
    serviceType?: EServiceType | string;
};
